import { Stringable } from '../Stringable';
import collect from 'collect.js';
import { Address } from '../../../types/order';

export default class AddressFormatter {
  private static country: string;

  public static setCountry(country: string): AddressFormatter {
    AddressFormatter.country = country;

    return new AddressFormatter();
  }

  public format(
    props: Pick<Address, 'street_name' | 'street_number' | 'city' | 'zip_code'>,
  ): string {
    return AddressFormatter.format(props);
  }

  public static format({
    street_name,
    street_number,
    city,
    state,
    country,
    zip_code,
  }: Partial<Address>): string {
    const address =
      {
        US: this.implode([this.implode([street_number, street_name], ' '), city, state, zip_code]),
      }[country ?? AddressFormatter.country] ??
      this.implode([
        this.implode([street_name, street_number], ' '),
        this.implode([zip_code, city], ' '),
      ]);

    return new Stringable(address).squish().toString();
  }

  private static implode(fields: string[], glue: string = ', '): string {
    return collect(fields)
      .filter((item) => item && item.length > 0)
      .implode(glue)
      .trim();
  }
}
